


const ProfileUser = () => {

    return (
    
        <div>
            perfil
        </div>

    )
}
export default ProfileUser;